import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import type { CreateOpeningInput, OpeningPreview, OpeningRow } from '@eombor/contracts';
import type { ApiClientError } from '../../../shared/api/client.js';
import { openingApi, type OpeningPage } from '../api/opening.api.js';

export const openingKeys = {
  list: (query: { page?: number; limit?: number }) => ['openings', 'list', query] as const,
};

export const useOpenings = (
  query: { page?: number; limit?: number } = {},
  enabled = true,
): UseQueryResult<OpeningPage, ApiClientError> =>
  useQuery<OpeningPage, ApiClientError>({
    queryKey: openingKeys.list(query),
    queryFn: () => openingApi.list(query),
    enabled,
    retry: false,
  });

/**
 * Kiritishdan keyin YANGILANADIGAN ro'yxatlar.
 *
 * Bo'linma qoldig'i ham, jurnal ham, panel raqamlari ham: kiritilgan
 * mol darhol «mening omborim» da ko'rinishi kerak. Yangilanmasa, odam
 * hujjat raqamini olgan bo'lsa-da, qoldiqda hech nima topmasdi.
 */
const invalidateAll = (queryClient: ReturnType<typeof useQueryClient>): void => {
  void queryClient.invalidateQueries({ queryKey: ['openings'] });
  void queryClient.invalidateQueries({ queryKey: ['subdivisions'] });
  void queryClient.invalidateQueries({ queryKey: ['storerooms'] });
};

/** Faylni tekshiradi — hech narsa yozmasdan, shuning uchun ro'yxat eskirmaydi. */
export const usePreviewOpening = () =>
  useMutation<OpeningPreview, ApiClientError, File>({
    mutationFn: (file) => openingApi.preview(file),
  });

export const useCreateOpening = () => {
  const queryClient = useQueryClient();

  return useMutation<OpeningRow, ApiClientError, CreateOpeningInput>({
    mutationFn: (input) => openingApi.create(input),
    onSuccess: () => invalidateAll(queryClient),
  });
};

export const useCancelOpening = () => {
  const queryClient = useQueryClient();

  return useMutation<OpeningRow, ApiClientError, string>({
    mutationFn: (id) => openingApi.cancel(id),
    onSuccess: () => invalidateAll(queryClient),
  });
};
